<template>
    <icon-base :fill="color" :size="size" class="icon-filter">
        <g id="grid">
            <g>
                <g>
                    <path d="M239.67,73.23H10.33c-5.43,0-9.83-4.4-9.83-9.83s4.4-9.83,9.83-9.83h229.34c5.43,0,9.83,4.4,9.83,9.83     S245.1,73.23,239.67,73.23z"/>
                </g>
                <g>
                    <path d="M239.67,134.83H10.33c-5.43,0-9.83-4.4-9.83-9.83c0-5.43,4.4-9.83,9.83-9.83h229.34     c5.43,0,9.83,4.4,9.83,9.83C249.5,130.43,245.1,134.83,239.67,134.83z"/>
                </g>
                <g>
                    <path d="M239.67,196.43H10.33c-5.43,0-9.83-4.4-9.83-9.83c0-5.43,4.4-9.83,9.83-9.83h229.34     c5.43,0,9.83,4.4,9.83,9.83S245.1,196.43,239.67,196.43z"/>
                </g>
                <g>
                    <circle cx="46.19" cy="63.4" r="25.13"/>
                </g>
                <g>
                    <circle cx="195.01" cy="125" r="25.13"/>
                </g>
                <g>
                    <circle cx="82.41" cy="186.6" r="25.13"/>
                </g>
            </g>
        </g>
    </icon-base>
</template>

<script>
export default {
    name:'iconDelivery',
    components:{
        IconBase: () => import('@/common/components/iconBase.vue')
    },
    props:{
        size: {
            type: Number,
            default: 20
        },
        color: {
            type: String,
            default: 'var(--main-navy)'
        },
        enableBackground: {
            type: Boolean
        }
    }
}
</script>

<style scoped>

</style>

